import {
  AgnesSheet,
  AgnesSheetContent,
  AgnesSheetHeader,
  AgnesSheetTitle,
  AgnesDataTable,
} from '@agnes/ui';
import { useCboStore } from '@/stores/useCboStore';
import { EmptyState } from '@/components/ui/EmptyState';
import { comQaNasCelulas } from '@/lib/dataQa';

type LinhaHistorico = { [k: string]: any };

export default function DrawerCboHistorico({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const historico = useCboStore((s) => s.historico);

  const columns = [
    {
      key: 'changedFieldDescriptiveName',
      header: 'Campo',
      width: 200,
      render: (r: LinhaHistorico) => r.changedFieldDescriptiveName ?? r.changedField ?? '-',
    },
    {
      key: 'fromValue',
      header: 'De',
      width: 200,
      render: (r: LinhaHistorico) =>
        r.fromValue || <span className="text-agnes-text-muted">-</span>,
    },
    {
      key: 'toValue',
      header: 'Para',
      width: 200,
      render: (r: LinhaHistorico) => r.toValue || <span className="text-agnes-text-muted">-</span>,
    },
    {
      key: 'updatedBy',
      header: 'Por',
      width: 160,
      render: (r: LinhaHistorico) =>
        r.updatedBy || <span className="text-agnes-text-muted">-</span>,
    },
    {
      key: 'updatedAt',
      header: 'Quando',
      width: 180,
      render: (r: LinhaHistorico) =>
        r.updatedAt || <span className="text-agnes-text-muted">-</span>,
    },
  ];

  const rowId = (r: LinhaHistorico) => String(r.id ?? `${r.changedField}-${r.updatedAt}`);
  const cols = comQaNasCelulas('cbo-historico-tabela', columns, rowId);

  return (
    <AgnesSheet
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <AgnesSheetContent
        side="right"
        className="flex w-full max-w-3xl flex-col p-0 sm:w-[720px]"
        dataQa="cbo-historico"
      >
        <AgnesSheetHeader
          className="border-b border-agnes-border px-4 py-3"
          data-qa="cbo-historico-cabecalho"
        >
          <AgnesSheetTitle data-qa="cbo-historico-titulo">Histórico da análise</AgnesSheetTitle>
        </AgnesSheetHeader>
        <div className="flex-1 overflow-auto p-4">
          {historico.length === 0 ? (
            <EmptyState dataQa="cbo-historico-vazio" title="Nenhuma alteração registrada" />
          ) : (
            <div className="overflow-x-auto">
              <AgnesDataTable<LinhaHistorico>
                dataQa="cbo-historico-tabela"
                columns={cols}
                data={historico}
                rowKey={rowId}
              />
            </div>
          )}
        </div>
      </AgnesSheetContent>
    </AgnesSheet>
  );
}
